import EditCannedMessageModalView from './EditCannedMessageView'
import {NinchatCannedMessage} from '../../../api/types/properties'
import {NinchatProperties} from '../../../api/types'
import React from 'react'
import {editCannedMessage} from '../../../actions/modal'
import {toast} from '../../Toast'
import {useAppDispatch} from '../../../hooks'
import {useCannedMessages} from 'hooks/cannedmessages/useSupportedLanguages'
import {useTranslation} from 'react-i18next'

type EditCannedMessageModalProps = {
    keyword?: string
    message?: string
    organization: boolean,
    realmId?: NinchatProperties.RealmID
}

const EditCannedMessageModal = (props: EditCannedMessageModalProps): React.ReactElement => {
    const {
        keyword,
        message,
        organization,
        realmId,
    } = props

    const dispatch = useAppDispatch()
    const {t} = useTranslation()
    const {
        cannedMessages, cannedMessagesLanguages, saveAvailable, save,
    } = useCannedMessages({
        organization,
        realmId,
    })

    const closeModal = () => {
        dispatch(editCannedMessage({
            organization,
            show: false,
        }))
    }

    const onCancel = () => {
        closeModal()
    }

    const onSave = (ninchatCannedMessages: NinchatCannedMessage[]) => {
        const successMsg = t('Canned message saved')
        const errorMsg = t('Error saving canned message')
        save(ninchatCannedMessages, cannedMessagesLanguages).then((success) => {
            if (success) {
                toast.success(successMsg)
            } else {
                toast.error(errorMsg)
            }
        })
        closeModal()
    }

    // todo ( for user canned messages, only use finnish and swedish at this moment )
    return (
        <EditCannedMessageModalView
            cannedMessages={cannedMessages}
            keyword={keyword}
            message={message}
            onCancel={onCancel}
            onSave={onSave}
            saveAvailable={saveAvailable}
            supportedCannedMessageLanguages={cannedMessagesLanguages}
        />
    )
}

EditCannedMessageModal.defaultProps = {
    keyword: undefined,
    message: undefined,
    realmId: undefined,
}

export default EditCannedMessageModal
